import { CardUser } from '@entities/user/ui/card-user/card-user';
import { styled } from 'goober';

export const LayoutCard = styled('div')`
    position: relative;
    display: flex;
    gap: 12px;
    margin: 0 20px 20px 20px;
    flex-grow: 1;
    flex-direction: column;
`;

export const StyledCardUser = styled(CardUser)`
    &:hover {
        cursor: pointer;
    }
`;
